import React, { useContext } from 'react';
import {
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import { Grid } from '@mui/material';
import Table from 'Components/Table/index';
import UsersColumns from './UserColumns';
import UserContext from '../context/UsersContext';
import { FirestoreUser } from 'generated/graphql';

const UsersTable: React.FC = () => {
    const { searchFilters, usersTable, users } = useContext(UserContext);

    const tableProps = useReactTable({
        columns: UsersColumns,
        data: searchFilters.length > 0 ? usersTable : users,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    return (
        <Grid item xs={12} mt={4}>
            <Table<FirestoreUser>
                containerSx={{ maxHeight: '600px', overflow: 'auto' }}
                tableProps={tableProps}
                stickyHeader
                canSort
            />
        </Grid>
    );
};

export default UsersTable;
